module.exports = __webpack_public_path__ + "img/7.4.NH3-N.c05a00d1.png";